import React from 'react';
import { Checkbox } from '@material-ui/core';

// Keep in sync with the legal texts approved by SB (docs/textos-legales-max.md, "Textos de la app" 1)
export const PolicyLinks = ({ terms }) => (
    <>
        <a href={terms?.privacy_url} target="_blank" rel="noreferrer" className="text-blue-800 underline">
            Privacy Policy
        </a>{' '}
        ·{' '}
        <a href={terms?.terms_url} target="_blank" rel="noreferrer" className="text-blue-800 underline">
            Terms and Conditions
        </a>
    </>
);

/**
 * Profile consent: the short notice, the Terms and Privacy Policy (required, recorded with its version) and
 * marketing messages (optional, CASL), kept apart.
 */
const TermsConsent = ({ form, setForm, terms }) => {
    const version = terms?.terms_version;
    const accepted = Boolean(form?.casl_provision_accepted) && (!version || form?.terms_version === version);

    const handleTerms = ({ target: { checked } }) => {
        setForm((prev) => ({
            ...prev,
            casl_provision_accepted: checked,
            ...(version ? { terms_version: checked ? version : prev.terms_version } : {})
        }));
    };

    const handleMarketing = ({ target: { checked } }) => {
        setForm((prev) => ({ ...prev, marketing_consent: checked }));
    };

    return (
        <div>
            <div className="font-bold mt-4">How we use your information</div>
            <p className="my-2">
                To review your application we collect your identity and legal-status documents, your banking
                information and, with your separate consent, your credit report. Our team is assisted by service
                providers, including AI-assisted review tools, some of which process information outside Canada.
                Decisions about your loan are always made by SimplyBorrowed staff. <PolicyLinks terms={terms} />
            </p>
            <div className="flex items-center">
                <Checkbox checked={accepted} onChange={handleTerms} />
                <span>I have read and agree to the Terms and Conditions and the Privacy Policy. (required)</span>
            </div>
            <div className="flex items-center">
                <Checkbox checked={Boolean(form?.marketing_consent)} onChange={handleMarketing} />
                <span>
                    Send me offers and news from SimplyBorrowed by email and text message. I can unsubscribe at
                    any time. (optional)
                </span>
            </div>
        </div>
    );
};

export default TermsConsent;
